import { render, staticRenderFns } from "./InvestorAddressData.vue?vue&type=template&id=03387de8&scoped=true&"
import script from "./InvestorAddressData.vue?vue&type=script&lang=js&"
export * from "./InvestorAddressData.vue?vue&type=script&lang=js&"
import style0 from "./InvestorAddressData.vue?vue&type=style&index=0&id=03387de8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03387de8",
  null
  
)

export default component.exports